import React from 'react';
import loadable from '@loadable/component';

import { ResponsiveImage } from '../../components';
import css from './ListingPage.module.css';

// Fallback component while the gallery is loading
const GalleryFallback = ({ images, imageVariants }) => {
  const firstImage = images?.[0] || null;
  return (
    <div className={css.productGallery}>
      <ResponsiveImage
        rootClassName={css.item}
        image={firstImage}
        alt=""
        variants={imageVariants}
        sizes="(max-width: 1024px) 100vw, (max-width: 1200px) calc(100vw - 192px), 708px"
      />
    </div>
  );
};

// Load the gallery only on client-side to avoid SSR issues with react-image-gallery
const ListingImageGallery = loadable(
  () => import(/* webpackChunkName: "ListingImageGallery" */ './ListingImageGallery/ListingImageGallery'),
  { 
    ssr: false,
    fallback: <div className={css.productGallery} style={{ minHeight: '400px' }} />
  }
);

const SectionGallery = props => {
  const { listing, variantPrefix } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  return (
    <div className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
      />
    </div>
  );
};

export default SectionGallery;
